import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Router, Switch, Route } from "wouter"; 
import "./index.css";
import { SWRConfig } from "swr";
import { Toaster } from "@/components/ui/toaster";

// Pages
import Dashboard from "./pages/dashboard";
import Vendors from "./pages/vendors";
import Roles from "./pages/roles";
import Candidates from "./pages/candidates";
import Analytics from "./pages/analytics";
import Login from "./pages/login";
import Register from "./pages/register";
import VendorDetails from "./pages/VendorDetails";
import Agency from "./pages/agency";
import AgencyDetails from "./pages/AgencyDetails";
import RoleDetails from "./pages/RoleDetails";
import SearchCandidates from "./pages/SearchCandidates";
import CandidateDetails from "./pages/CandidateDetails";
import hr from "./pages/hr";
import HRDetails from "./pages/HRDetails";
import SearchRoles from "./pages/SearchRoles";
import LinkedInSearch from "./pages/linkedinsearch";
import { supabase } from "../../client/supabaseClient";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Router> 
      <SWRConfig
        value={{
          fetcher: async (key: string) => {
            const { data, error } = await supabase
              .from(key)
              .select('*');
            
            if (error) throw error;
            return data;
          }
        }}
      >
        <Switch>
          <Route path="/" component={Dashboard} />
          <Route path="/vendors" component={Vendors} />
          <Route path="/agencies" component={Agency} />
          <Route path="/roles" component={Roles} />
          <Route path="/candidates" component={Candidates} />
          <Route path="/search-candidates/:roleId" component={SearchCandidates} />
          <Route path="/search-roles/:candidateId" component={SearchRoles } />
          <Route path="/analytics" component={Analytics} />
          <Route path="/login" component={Login} />
          <Route path="/register" component={Register} />
          <Route path="/vendor-details/:vendorId" component={VendorDetails} />
          <Route path="/agency-details/:agencyId" component={AgencyDetails} />
          <Route path="/role-details/:roleId" component={RoleDetails} />
          <Route path="/candidate-details/:candidateId" component={CandidateDetails} />
          <Route path="/hr-details/:hrId" component={HRDetails} />
          <Route path="/hr" component={hr} />
          <Route path="/linkedinsearch" component={LinkedInSearch} />


          <Route>404 Page Not Found</Route>
        </Switch>
        <Toaster />
      </SWRConfig>
    </Router>
  </StrictMode>
);
